export default "__VITE_ASSET__BDW1$TeP__"